<div class="parent">
    <div>
        <mat-button-toggle-group class="interaction-group">
            <mat-button-toggle (change)="changeInteractionMode($event)" [checked]="placeLandmarks"
                               value="placeLandmarks">
                <mat-icon>place</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle (change)="changeInteractionMode($event)" [checked]="!placeLandmarks" value="pan" *ngIf="mode !== 'image'">
                <!--*ngIf="mode == 'model'">-->
                <mat-icon>pan_tool</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle (change)="checkPlacementButton($event)" (click)="dataExchangeService.image.clearLandmarks()">
                <mat-icon>clear</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <div class="view">
        <surface-picture-landmark></surface-picture-landmark>
    </div>
    <div class="button-group">
        <mat-button-toggle-group [multiple]="true" class="navigation-group">
            <mat-button-toggle (change)="untoggleButton($event)" (click)="back()">
                <mat-icon>arrow_left</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle (change)="untoggleButton($event)"
                               (click)="nextView()" *ngIf="mode == 'image'">
                <mat-icon>arrow_right</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle (change)="closeView()" *ngIf="mode == 'model'"
                               [disabled]="dataExchangeService.image.imageLandmarkCount != dataExchangeService.image.modelLandmarkCount">
                <mat-icon>check</mat-icon>
            </mat-button-toggle>
        </mat-button-toggle-group>
    </div>

</div>


<mat-card class="overlay">

    <mat-card-content>
        <h4>Markers: &nbsp;</h4>
        <h5 *ngIf="mode == 'image'">{{dataExchangeService.image.imageLandmarkCount}}</h5>
        <h5 *ngIf="mode == 'model'">{{dataExchangeService.image.modelLandmarkCount}}</h5>
        <h5 *ngIf="mode == 'model'">{{'/' + dataExchangeService.image.imageLandmarkCount}}</h5>
    </mat-card-content>

</mat-card>



